import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountDetailService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  AccountDetailCreateDto,
  AccountDetailDto,
  AccountDetailExcelDownloadDto,
  AccountDetailUpdateDto,
} from '../proxy/controlling/dtos/account-detail';
import { ACCOUNTDETAIL_CONFIG, ACCOUNTDETAIL_FIELDS } from './account-detail.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-account-detail',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, AccountDetailService, ConfirmationService],
  templateUrl: './account-detail.html',
  styleUrl: './account-detail.scss',
})
export class AccountDetail extends BaseHierarchicalCrudComponent<
  AccountDetailDto,
  AccountDetailCreateDto,
  AccountDetailUpdateDto,
  AccountDetailExcelDownloadDto
> {
  service = inject(AccountDetailService);
  config = ACCOUNTDETAIL_CONFIG;
  fields = ACCOUNTDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: AccountDetailDto): AccountDetailUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'AccountDetail';
  }
}
